import { API } from '@aws-amplify/api'
import { useQuery } from 'react-query'
import * as Sentry from '@sentry/nextjs'

import { Listing, PhotoResolutions } from './getListings'

export type IndividualListing = Listing & {
  photo_resolutions: PhotoResolutions[]
  sale_date: string | null
  mlsIdx: {
    feedName: string
    brokerage: string
    number: string
    status: string
    logoUrl: string
    soldDate: string | null
    soldPrice: string | null
    /** Feed-level sync watermark (mls_feeds.last_synced) — drives the MLS
     * GRID "as of" disclaimer. Optional: stale cached payloads lack it. */
    dataObtainedAt?: string | null
  }
  list_agent: {
    /** null when raw_data lacks ListAgentFullName — the common MLS gap. */
    full_name: string | null
    phone_number?: string | null
  }
  acreApproved: boolean
}

const getListingById = async (lid: number): Promise<IndividualListing> => {
  return API.get('listing', `/listing/${lid}/details`, {}).catch(
    captureExceptionAndThrow
  )
}

export const useListingDetails = (
  lid: number,
  initialData?: IndividualListing,
  disabled?: boolean
) => {
  return useQuery(['getListingById', lid], () => getListingById(lid), {
    initialData: initialData,
    enabled: !disabled,
  })
}

function captureExceptionAndThrow(error: unknown) {
  Sentry.captureException(error)

  throw error
}
